/**
 * CaseManageSlice State Definition
 * 
 * Defines the state interface and initial state for the case manage slice.
 */

import { CaseManageView } from '../types/caseManageTypes';

/**
 * State interface for the case manage slice.
 * Follows the standard BaseSliceState pattern with case-specific naming.
 */
export interface CaseManageSliceState {
  /** The current case being viewed/edited, or null if none selected */
  currentCase: CaseManageView | null;
  /** Whether any edits have been made since loading/saving */
  isEdited: boolean;
  /** List of field names that have been modified */
  editedFields: string[];
  /** Validation errors keyed by field name */
  validationErrors: Record<string, string>;
}

/**
 * Initial state for the case manage slice.
 */
export const initialState: CaseManageSliceState = {
  currentCase: null,
  isEdited: false,
  editedFields: [],
  validationErrors: {},
};
